import { useEffect } from "react";

const SITE_URL = "https://www.agilustech.in";
const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`;

// Imperatively upsert a <meta> tag by its identifying attribute (name / property).
function upsertMeta(attr, key, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

// Upsert a <link rel="..."> tag.
function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// Per-page SEO/meta. Written imperatively (like the existing `document.title`
// effects) so react-snap reliably captures the tags into each static HTML file.
// The page's own effect owns <title>; this owns description/canonical/social.
export default function Seo({ title, description, path = "", image }) {
  useEffect(() => {
    const url = `${SITE_URL}${path}`;
    const ogTitle = title ? `${title} | Agilus Technologies` : document.title;
    const img = image || DEFAULT_IMAGE;

    upsertMeta("name", "description", description);
    upsertLink("canonical", url);

    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:site_name", "Agilus");
    upsertMeta("property", "og:title", ogTitle);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", img);

    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", ogTitle);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", img);
  }, [title, description, path, image]);

  return null;
}
